import moment from "moment"
import { apolloVuexListStoreFactory } from '../../../libs/ApolloVuexListStore'

import { URGENT_CUSTOMER_NEWS_QUERY } from './graphql'

const store = apolloVuexListStoreFactory({
  settings: {
    fetchAllQuery: URGENT_CUSTOMER_NEWS_QUERY,
    fetchAllFieldName: 'urgentCustomerNews',
  },
  getters: {
    withIsUnread(state, getters, rootState) {
      let news = []
      for (let entry of state.entries) {
        entry.isUnread = false
        if (moment(entry.createdAt) > rootState.uiStore.lastNewsVisitDate) {
          entry.isUnread = true
        }
        news.push(entry)
      }
      return news
    },
  }
})

export default store
